export default __webpack_public_path__ + "static/media/5_2.a4759a04.png";